// src/admin/routes.tsx
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/login/LoginScreen';
import TotpChallenge from './screens/login/TotpChallenge';
import EnrolTotp from './screens/login/EnrolTotp';
import AcceptInvite from './screens/login/AcceptInvite';
import ResetPassword from './screens/login/ResetPassword';
import DashboardScreen from './screens/dashboard/DashboardScreen';
import LoansQueueScreen from './screens/loans/LoansQueueScreen';
import LoanDetailScreen from './screens/loans/LoanDetailScreen';
import BorrowersListScreen from './screens/borrowers/BorrowersListScreen';
import BorrowerDetailScreen from './screens/borrowers/BorrowerDetailScreen';
import KycQueueScreen from './screens/kyc/KycQueueScreen';
import KycReviewScreen from './screens/kyc/KycReviewScreen';
import CollectionsQueueScreen from './screens/collections/CollectionsQueueScreen';
import CollectionsDetailScreen from './screens/collections/CollectionsDetailScreen';
import AuditLogScreen from './screens/audit/AuditLogScreen';
import AdminsListScreen from './screens/admins/AdminsListScreen';
import AdminDetailScreen from './screens/admins/AdminDetailScreen';
import SystemConfigScreen from './screens/config/SystemConfigScreen';
import ActionRequestsScreen from './screens/actions/ActionRequestsScreen';
import { ProtectedRoute } from './auth/ProtectedRoute';
import AppShell from './shell/AppShell';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/login/totp" element={<TotpChallenge />} />
      <Route path="/login/enrol-totp" element={<EnrolTotp />} />
      <Route path="/accept-invite/:token" element={<AcceptInvite />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route element={<ProtectedRoute />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<DashboardScreen />} />
          <Route path="/loans" element={<LoansQueueScreen />} />
          <Route path="/loans/:id" element={<LoanDetailScreen />} />
          <Route path="/borrowers" element={<BorrowersListScreen />} />
          <Route path="/borrowers/:id" element={<BorrowerDetailScreen />} />
          <Route path="/kyc" element={<KycQueueScreen />} />
          <Route path="/kyc/:id" element={<KycReviewScreen />} />
          <Route path="/collections" element={<CollectionsQueueScreen />} />
          <Route path="/collections/:id" element={<CollectionsDetailScreen />} />
          <Route path="/audit" element={<AuditLogScreen />} />
          <Route path="/admins" element={<AdminsListScreen />} />
          <Route path="/admins/:id" element={<AdminDetailScreen />} />
          <Route path="/config" element={<SystemConfigScreen />} />
          <Route path="/actions" element={<ActionRequestsScreen />} />
          {/* Routes land in later phases */}
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
